import type { Locale } from '@core/i18n';
import type { Bcp47Locale } from './user-preferences.types';

/**
 * Convertit un tag BCP-47 (contrat backend) en code Locale court (i18n interne).
 * Retourne `null` si la valeur n'est pas reconnue — l'appelant décide du fallback.
 */
export function bcp47ToLocale(bcp47: string): Locale | null {
  const base = bcp47.split('-')[0]?.toLowerCase();
  if (base === 'fr') return 'fr';
  if (base === 'en') return 'en';
  return null;
}

/**
 * Convertit un code Locale court vers un tag BCP-47 supporté par le backend.
 */
export function localeToBcp47(locale: Locale): Bcp47Locale {
  switch (locale) {
    case 'fr':
      return 'fr-FR';
    case 'en':
      return 'en-US';
  }
}
